import { useAtom } from "jotai";
import React, { useState } from "react";
import { selectedUserAtom } from "../config/globalStates";
import { useItemsFilter } from "../apis/queries";
import LabTestCard from "../components/LabTestCard";
import CuStatusMessage from "./CuStatusMessage";
import CuScreenLoader from "../components/CuScreenLoader";
import { cufrontIcons } from "../assets/icons/icons";
import moment from "moment";
import MedicalRecordCard from "../components/MedicalRecordCard";
import { useDeleteItem } from "../apis/mutations";
import { useMediaQuery } from "react-responsive";
import Confirmation from "../components/Confirmation";
import CuModal from "./CuModal";
import CuMobileModal from "../components/CuMobileModal";
import { getImageURL } from "../apis/image";
import ImagePreview from "../components/ImagePreview";

const LabTest = ({ data, isLoading }) => {
    const sm = !useMediaQuery({ query: "(min-width:768px)" });
    const [selectedUser] = useAtom(selectedUserAtom);
    const [openModal, setOpenModal] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState("");
    const [openPdfViewer, setOpenPdfViewer] = useState(false);
    const [pdfData, setPdfData] = useState([]);
    const [mainImage, setMainImage] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const deleteRecordsMutation = useDeleteItem("users/");

    const handleDelete = (id) => {
        const payload = {
            action: "delUserRecords",
            frontend: "True",
            id: selectedDeleteId,
            clinic_id: 1,
        };

        deleteRecordsMutation.mutate(
            { data: payload },
            {
                onSuccess: () => {
                    setOpenModal(false);
                    setSelectedDeleteId("");
                },
                onError: () => {
                    setSelectedDeleteId("");
                },
            }
        );
    };

    const handleOpenPdfViewer = (item) => {
        setPdfData(item);
        setOpenPdfViewer(!openPdfViewer);
    };

    console.log(pdfData,"-----pdfData------")

    return (
        <>
            {isLoading ? (
                <CuScreenLoader />
            ) : (
                <div>
                    {data?.length > 0 ? (
                        <div className="mt-5">
                            {data?.map((item, i) => (
                                <div className="mt-5" key={i}>
                                    <MedicalRecordCard
                                        item={item}
                                        title={item?.file_name}
                                        date={moment(item.created_At).format(
                                            "DD MMM YYYY"
                                        )}
                                        handleDelete={() => (
                                            setSelectedDeleteId(item?.id),
                                            setOpenModal(true)
                                        )}
                                        handleOpenPdfViewer={() =>
                                            handleOpenPdfViewer(item)
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <CuStatusMessage
                            heading={"You don’t have any labtest"}
                            description={"Hey you don't have any  labtests"}
                            img={cufrontIcons?.NoAppointment}
                        />
                    )}
                    {!!openModal && (
                        <CuModal closeModal={() => setOpenModal(false)}>
                            <Confirmation
                                heading={"Delete Lab Report"}
                                onClick={handleDelete}
                                onCancel={() => setOpenModal(false)}
                                loading={deleteRecordsMutation.isLoading}
                            />
                        </CuModal>
                    )}
                </div>
            )}

{openPdfViewer && (
  <ImagePreview
    uploadedFile={
      pdfData?.files?.flat().length > 0 
        ? pdfData.files.flat() 
        : [{ filename: pdfData?.files_id, url: pdfData?.files_id }]
    }
    mainImage={mainImage}
    setMainImage={setMainImage}
    setShowPreview={setOpenPdfViewer}
    setSelectedIndex={setSelectedIndex}
    selectedIndex={selectedIndex}
  />
)}
        </>
    );
};

export default LabTest;
